<template>
  <div style="display: unset">
    <b-btn size="sm" variant="success" @click="onSelectStaff()">
      <font-awesome-icon :icon="['fas', 'plus']" />
      Выбрать сотрудников
    </b-btn>

    <b-modal
      id="modal-staff-select"
      v-show="show"
      content-class="modal-fullscreen"
      body-class="modal-body-fullscreen"
      size="xl"
      ref="modalStaffsSelect"
      title="Персонал"
      :ok-only="false"
      :no-fade="true"
      @ok="onOk"
      @cancel="onCancel"
      @close="onCancel"
      ok-title="Выбрать"
      cancel-title="Отменить"
      button-size="sm"
      no-close-on-esc
      no-close-on-backdrop
      scrollable
    >
      <b-navbar id="" class="mb-1">
        <b-navbar-nav>
          <b-form inline @submit.prevent="onSearch()">
            <b-form-input
              class="mr-2"
              size="sm"
              v-model="filters.query"
              debounce="500"
              placeholder="Поиск" />

            <organization-select
              class="mr-2"
              id="input-org-select"
              ref="organization_select"
              v-on:onSelect="onSelectOrg"/>

            <department-select
              class="mr-2"
              id="input-department-select"
              ref="department_select"
              v-on:onSelect="onSelectDepartment"/>

            <job-title-select
              class="mr-2"
              id="input-job-title-select"
              ref="job_title_select"
              v-on:onSelect="onSelectJobTitle"/>

            <b-button
              class="mr-1"
              size="sm"
              variant="outline-success"
              @click.prevent="onSearch()"
            >
              Применить
            </b-button>
          </b-form>
        </b-navbar-nav>
      </b-navbar>

      <b-table
        id="staffs"
        ref="staffs"
        class="mb-0 text-small"
        select-mode="multi"
        selectedVariant="success"
        striped
        small
        responsive
        show-empty
        :empty-text="$t('message.common.emptyTable')"
        :busy="isBusy"
        :items="items"
        :fields="fields"
        no-provider-filtering
        no-provider-paging
        no-provider-sorting
        @row-clicked="onRowClicked"
        :tbody-tr-class="tbodyRowClass"
        sticky-header
        head-variant="light"
      >
        <template #table-busy>
          <div class="text-center text-success my-2">
            <b-spinner class="align-middle"/>
            <strong>Загрузка</strong>
          </div>
        </template>

        <template #head(selected)="row">
          <b-form-checkbox
            class="mx-1"
            v-model="allSelected"
            :indeterminate="indeterminate"
            :disabled = "allSelectDisabled"
            size="md"
            @change="selectAllRows"
          ></b-form-checkbox>
        </template>

        <template #cell(selected)="row">
          <template v-if="row.item.selected">
            <span aria-hidden="true">&check;</span>
            <span class="sr-only">Выбрана</span>
          </template>
          <template v-else>
            <span >&nbsp;</span>
            <span class="sr-only">Не выбрана</span>
          </template>
        </template>

        <template #cell(name)="row">
          {{ getShortName(row.item.surname, row.item.name, row.item.patronymic) }}
        </template>

        <template #cell(migration_entry_date)="row">
          {{formatTableDate(row.item.migration_entry_date)}}
        </template>

        <template #cell(contract_add_date)="row">
          {{formatTableDate(row.item.contract_add_date)}}
        </template>

        <template #cell(patent_issue_date)="row">
          {{formatTableDate(row.item.patent_issue_date)}}
        </template>

        <template #cell(patent_expiration)="row">
          {{formatTableDate(row.item.patent_expiration)}}
        </template>
        <template #cell(salary)="row">
          {{priceFormat(row.item.salary)}}
        </template>
        <template #cell(contract_salary)="row">
          {{priceFormat(row.item.contract_salary)}}
        </template>
      </b-table>

      <pagination-footer
        :total-rows="totalRows"
        :per-page.sync="perPage"
        @page-click="onPagination"
        @per-page-change="onPerPageChange"
      />

    </b-modal>
  </div>
</template>

<script>
import staff from "../../network/staff";
  import helpers from "../../utilites/helpers";
  import dateFormatter from "../../utilites/dateFormatter";
  import PaginationFooter from "../../utilites/commonUi/PaginationFooter.vue";
  import pageSearchService from "../../utilites/pageSearchService";
    import DepartmentSelect from "../Catalogs/Departments/DepartmentSelect";
    import OrganizationSelect from "../Organizations/OrganizationSelect";
    import JobTitleSelect from "../Catalogs/JobTitles/JobTitleSelect";

export default {
  name: "StaffMultiSelect",
  components: { PaginationFooter, OrganizationSelect, JobTitleSelect, DepartmentSelect },
  mixins: [
    staff,
    helpers, dateFormatter, pageSearchService
  ],
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: [Array],
      default: []
    },
  },
  data() {
    return {
      show: false,
      selectedItems: [],
      items: [],
      fields: [
        {
          key: 'selected',
          label: '',
          class:'staff-select'
        },
        {
          key: 'id',
          sortable: false,
          class: 'staff-id'
        },
        {
          key: 'name',
          label: "ФИО",
          sortable: false,
          class: 'staff-name'
        },
        {
          key: 'organization_name',
          label: "Организация",
          sortable: false,
          class: 'staff-organization-name'
        },
        {
          key: 'department_name',
          label: "Подразделение",
          sortable: false,
          class: 'staff-department-name'
        },
        {
          key: 'job_title_name',
          label: "Должность",
          sortable: false,
          class: 'staff-job-title-name'
        },
        {
          key: 'contract_add_date',
          label: "Дата приёма",
          sortable: false,
          class: 'staff-contract-add-date'
        },
        {
          key: 'inn',
          label: "ИНН",
          sortable: false,
          class: 'staff-inn'
        },
        {
          key: 'snils',
          label: "СНИЛС",
          sortable: false,
          class: 'staff-snils'
        },
        {
          key: 'salary',
          label: "Оклад",
          sortable: false,
          class: 'staff-salary',
          formatter: 'priceFormat',
        },
        {
          key: 'salary_rate',
          label: "Ставка",
          sortable: false,
          class: 'staff-salary-rate'
        },
        {
          key: 'contract_salary',
          label: "По договору",
          sortable: false,
          class: 'staff-contract-salary',
          formatter: 'priceFormat',
        },
      ],
      isBusy: false,
      sortBy: 'id',
      sortDesc: true,
      filters: {
        query: '',
        organization_id: null,
        job_title_id: null,
        department_id: null,
      },
      allSelected: false,
      indeterminate: false,
      allSelectDisabled: true,
    }
  },
  async created() {
    const query = this.$route.query;

    if (query && query.query) {
      this.filters.query = query.query;
    }

    if (this.$route.hash) {
      this.currentPage = this.getPage(this.$route.hash);
    }

    await this.getItems();
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.selectedItems = newVal;
        } else {
          this.selectedItems = [];
        }
      }
    },
    selectedItems(newValue, oldValue) {
      if (newValue.length === 0) {
        this.indeterminate = false;
        this.allSelected = false;
      } else if (newValue.length === this.totalRows) {
        this.indeterminate = false;
        this.allSelected = true;
      } else {
        this.indeterminate = true;
        this.allSelected = false;
      }
    },
    totalRows(newValue, oldValue) {
      if (newValue === 0) {
        this.allSelectDisabled = true;
      } else if (newValue > 10000) {
        this.allSelectDisabled = true;
      } else {
        this.allSelectDisabled = false;
      }
    },
  },
  methods: {
    async getItems() {
      const data = {
        page: this.currentPage,
        size: this.perPage,
        query: this.filters.query,
        organization_id: this.filters.organization_id,
        job_title_id: this.filters.job_title_id,
        department_id: this.filters.department_id,
      }

      this.isBusy = true;
      const result = await this.getStaffs(data);
      this.isBusy = false;

      if (result.data == null) {
        this.items = [];
        this.totalRows = 0;
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        return;
      }

      this.items = result.data.items;
      this.totalRows = result.data.total;

      this.updateSelected();
    },
    updateSelected() {
      this.items.forEach((item) => {
        const isSelected = this.selectedItems.some(e => e.id === item.id);
        this.$set(item, 'selected', isSelected);
      });
    },
    tbodyRowClass(item) {
      return item && item.selected ? ["b-table-row-selected", "table-primary", "pointer-cell"] : ["pointer-cell"];
    },
    onRowClicked(item) {
      // Ищем уже выбранные
      const existItem = this.selectedItems.findIndex(e => e.id === item.id);

      if (existItem !== -1) {
        this.selectedItems.splice(existItem, 1);
        this.$set(item, 'selected', false);
      } else {
        this.selectedItems.push(item);
        this.$set(item, 'selected', true);
      }
    },
    getShortName(surname, name, patronymic) {
      const firstCharName = name.slice(0,1);
      const firstCharPatronymic = patronymic.slice(0,1);
      if (firstCharPatronymic === '') {
        return `${surname} ${firstCharName}.`;
      }
      return `${surname} ${firstCharName}. ${firstCharPatronymic}.`;
    },
    onOk() {
      this.$emit('change', this.selectedItems);
      this.$refs.modalStaffsSelect.hide();
      this.selectedItems = [];
      this.updateSelected();
    },
    onCancel() {
      this.$refs.modalStaffsSelect.hide();
      this.selectedItems = [];
      this.updateSelected();
    },
    onSelectStaff() {
      this.$refs.modalStaffsSelect.show();
      this.updateSelected();
    },
    async selectAllRows(checked) {
      if (checked) {
        if (this.totalRows > 10000) {
          const message = "Большое количество записей. Отфильтруйте данные";
          this.showError(message);
          this.allSelected = false;
          return;
        }

        this.selectedItems = await this.getAllItems();
        this.updateSelected();
      } else {
        this.selectedItems = [];
        this.updateSelected();
      }
    },
    async getAllItems() {
      const data = {
        page: 1,
        size: this.totalRows,
        query: this.filters.query,
        organization_id: this.filters.organization_id,
        job_title_id: this.filters.job_title_id,
        department_id: this.filters.department_id,
      }

      const result = await this.getStaffs(data);

      if (!result || !result.data) {
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        return;
      }

      return result.data.items.length > 0 ? result.data.items : [];
    },
    async onSelectOrg(orgId) {
      this.filters.organization_id = orgId;
    },
    async onSelectJobTitle(id) {
      this.filters.job_title_id = id;
    },
    async onSelectDepartment(item) {
      if (item == null) {
        this.filters.department_id = null
        return;
      }
      this.filters.department_id = item.id;
    },
  }
}
</script>

<style>
.staff-select {
  min-width: 50px;
  text-align: center;
}

.staff-id {
  padding-left: 10px !important;
  width: 60px;
  text-align: center;
}

.staff-active {
  text-align: center;
}

.staff-action {
  width: 80px;
  padding-right: 10px !important;
  text-align: center;
}

.staff-contract-salary {

}

#modal-staff-select .modal-dialog {
  max-width: 100% !important;
  max-height: 100% !important;
  height: 100% !important;
  margin: 0 !important;
}

.modal-fullscreen {
  max-height: 100% !important;
  height: 100% !important;
}

.modal-body-fullscreen {
  padding-bottom: 0  !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Staff/StaffMultiSelect.vue